import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgRechten = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#BECBE5"
      fillRule="evenodd"
      d="M8.71 5 31 10.056l-.71 3.598-9.076-2.059v16.808h7.288V33H10.498v-4.597h7.287V10.817L8 8.597z"
      clipRule="evenodd"
    />
    <path
      fill="#E0E8F6"
      d="M10.5 17a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5M28.5 23a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7"
    />
    <path
      fill="#BECBE5"
      fillRule="evenodd"
      d="M35 19c0 3.314-2.462 6-5.5 6S24 22.314 24 19z"
      clipRule="evenodd"
    />
    <path
      fill="#00215B"
      d="M30.5 21h-1v-9h1z"
    />
    <path
      fill="#BECBE5"
      fillRule="evenodd"
      d="M15 14c0 3.314-2.462 6-5.5 6S4 17.314 4 14z"
      clipRule="evenodd"
    />
    <path
      fill="#00215B"
      d="M9.5 16h-1V8h1zM30 30.5v1H15v-1z"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgRechten);

export default ForwardRef;
